// apps/api/src/qxcircle/qxcircle-draft.ts
// Description: QXCircle compose draft — local save, not a post (Slice 21).
// Owner: Masa Bayu
// Date: 2026-08-24

import { BadRequestException } from "./_nestjs-common";
import type { QxCircleComposeDraft } from "./qxcircle.types";
import { QXCIRCLE_POST_BODY_MAX } from "./qxcircle.types";

export function emptyQxCircleDraft(): QxCircleComposeDraft {
  return {
    body: "",
    updatedAt: null,
    world: "qxcircle",
    slice: "draft",
  };
}

export function saveQxCircleDraft(bodyRaw: string): QxCircleComposeDraft {
  const body = String(bodyRaw ?? "");
  if (body.length > QXCIRCLE_POST_BODY_MAX) {
    throw new BadRequestException(
      `Draft body max ${QXCIRCLE_POST_BODY_MAX} characters`,
    );
  }
  return {
    body,
    updatedAt: new Date().toISOString(),
    world: "qxcircle",
    slice: "draft",
  };
}
